import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/clients")({
  component: ClientsLayout,
});

function ClientsLayout() {
  return (
    <div className="px-6 py-6 max-w-[1480px] mx-auto">
      <header className="mb-5">
        <p className="text-xs text-ink-500 mb-1">HOLACLIENTE</p>
        <h1 className="text-2xl font-bold text-ink-900 dark:text-white">Clientes</h1>
        <p className="text-sm text-ink-500 mt-1">
          Clientes de la cuenta — usados en monitoreo social (proyectos) y en medios tradicionales
          (campañas, avisos y reportes). Cada cliente tiene un slug único para su portal público.
        </p>
      </header>
      <Outlet />
    </div>
  );
}
